var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('v-btn',{attrs:{"color":"gray","to":_vm.url}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_vm._v(" Повернутися ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }